<template>
  <div>
    <countdown/>
    <banner/>
  </div>
</template>

<script>
import Countdown from '@/Countdown';
import Banner from '@/Banner';

export default {
  name: 'App',
  components: {
    Countdown,
    Banner
  },
  methods: {
    setViewportHeightUnit() {
      document.documentElement.style.setProperty(
          '--vh',
          `${ window.innerHeight * 0.01 }px`
      );
    }
  },
  mounted() {
    this.setViewportHeightUnit();

    window.addEventListener( 'resize', this.setViewportHeightUnit );
  }
}
</script>

<style lang="scss" scoped>

</style>
